module.exports = __webpack_public_path__ + "static/media/math.d629d93d.svg";